export const Estados = [
  {
    id: "1",
    estado: "AC",
    nome: "ACRE",
    aliquota: "250.50",
    codibge: "12",
    iest: null,
  },
  {
    id: "2",
    estado: "AL",
    nome: "ALAGOAS",
    aliquota: null,
    codibge: "27",
    iest: null,
  },
  {
    id: "3",
    estado: "AP",
    nome: "AMAPÁ",
    aliquota: null,
    codibge: "16",
    iest: null,
  },
  {
    id: "5",
    estado: "BA",
    nome: "BAHIA",
    aliquota: null,
    codibge: "29",
    iest: null,
  },
  {
    id: "6",
    estado: "CE",
    nome: "CEARÁ",
    aliquota: null,
    codibge: "23",
    iest: null,
  },
  {
    id: "7",
    estado: "DF",
    nome: "DISTRITO FEDERAL",
    aliquota: null,
    codibge: "53",
    iest: null,
  },
  {
    id: "8",
    estado: "ES",
    nome: "ESPÍRITO SANTO",
    aliquota: null,
    codibge: "32",
    iest: null,
  },
  {
    id: "9",
    estado: "GO",
    nome: "GOIÁS",
    aliquota: null,
    codibge: "52",
    iest: null,
  },
  {
    id: "10",
    estado: "MA",
    nome: "MARANHÃO",
    aliquota: null,
    codibge: "21",
    iest: null,
  },
  {
    id: "11",
    estado: "MT",
    nome: "MATO GROSSO",
    aliquota: null,
    codibge: "51",
    iest: null,
  },
  {
    id: "12",
    estado: "MS",
    nome: "MATO GROSSO DO SUL",
    aliquota: null,
    codibge: "50",
    iest: null,
  },
  {
    id: "13",
    estado: "MG",
    nome: "MINAS GERAIS",
    aliquota: null,
    codibge: "31",
    iest: null,
  },
  {
    id: "14",
    estado: "PA",
    nome: "PARÁ",
    aliquota: null,
    codibge: "15",
    iest: null,
  },
  {
    id: "15",
    estado: "PB",
    nome: "PARAÍBA",
    aliquota: null,
    codibge: "25",
    iest: null,
  },
  {
    id: "16",
    estado: "PR",
    nome: "PARANÁ",
    aliquota: null,
    codibge: "41",
    iest: null,
  },
  {
    id: "17",
    estado: "PE",
    nome: "PERNAMBUCO",
    aliquota: null,
    codibge: "26",
    iest: null,
  },
  {
    id: "18",
    estado: "PI",
    nome: "PIAUÍ",
    aliquota: null,
    codibge: "22",
    iest: null,
  },
  {
    id: "19",
    estado: "RJ",
    nome: "RIO DE JANEIRO",
    aliquota: null,
    codibge: "33",
    iest: null,
  },
  {
    id: "20",
    estado: "RN",
    nome: "RIO GRANDE DO NORTE",
    aliquota: null,
    codibge: "24",
    iest: null,
  },
  {
    id: "21",
    estado: "RS",
    nome: "RIO GRANDE DO SUL",
    aliquota: null,
    codibge: "43",
    iest: null,
  },
  {
    id: "22",
    estado: "RO",
    nome: "RONDÔNIA",
    aliquota: null,
    codibge: "11",
    iest: null,
  },
  {
    id: "23",
    estado: "RR",
    nome: "RORAIMA",
    aliquota: "20.00",
    codibge: "14",
    iest: null,
  },
  {
    id: "24",
    estado: "SC",
    nome: "SANTA CATARINA",
    aliquota: null,
    codibge: "42",
    iest: null,
  },
  {
    id: "25",
    estado: "SP",
    nome: "SÃO PAULO",
    aliquota: "63.50",
    codibge: "35",
    iest: null,
  },
  {
    id: "26",
    estado: "SE",
    nome: "SERGIPE",
    aliquota: null,
    codibge: "28",
    iest: null,
  },
  {
    id: "27",
    estado: "TO",
    nome: "TOCANTINS",
    aliquota: "256.80",
    codibge: "17",
    iest: null,
  },
  {
    id: "28",
    estado: "EX",
    nome: "EXTERIOR",
    aliquota: null,
    codibge: "99",
    iest: null,
  },
  {
    id: "4",
    estado: "AM",
    nome: "AMAZONAS",
    aliquota: null,
    codibge: "13",
    iest: null,
  },
];
